import { render, staticRenderFns } from "./ConfigureSubdivisionsModal.vue?vue&type=template&id=568b30a7&scoped=true"
import script from "./ConfigureSubdivisionsModal.vue?vue&type=script&lang=js"
export * from "./ConfigureSubdivisionsModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSubdivisionsModal.vue?vue&type=style&index=0&id=568b30a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b30a7",
  null
  
)

export default component.exports